// extracted by mini-css-extract-plugin
module.exports = {"container":"UpgradePrompt__container___EpyaG","cta":"UpgradePrompt__cta___1+lfk","icon":"UpgradePrompt__icon___JmfSV","header":"UpgradePrompt__header___SeAXx"};